import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid } from 'redux-form'
import { Row, Col, Button } from 'react-bootstrap'

import * as actions from '../../../actions'
import { FORM_ABANDONO } from '../../../../../config/forms'
import MotivosAbandono from
  '../../../../Forms/SharedComponents/containers/MotivosAbandono'
import StatusModal from
  '../../../../Forms/SharedComponents/containers/StatusModal'

class Abandono1 extends Component {
  render () {
    const {
      handleSubmit,
      invalid,
      abandonoShowSaveModal,
      abandonoSaveResponse,
      onPrev,
      hideAbandonoSaveMessageModal
    } = this.props

    return (
      <div>
        <StatusModal
          show={abandonoShowSaveModal}
          onClick={hideAbandonoSaveMessageModal}
          errorMessage={abandonoSaveResponse}
          extraErrorMessage={null}
        />
        <form onSubmit={handleSubmit}>
          <Row>
            <Col md={12}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <MotivosAbandono />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button style={{ margin: '2%' }} onClick={() => onPrev()} size='lg'>Cancelar</Button>
                <Button style={{ margin: '2%' }} type='submit' disabled={invalid} size='lg'>Siguiente</Button>
              </div>
            </Col>
          </Row>
        </form>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_ABANDONO)(state),
  abandonoSaveResponse: state.camionesIngreso.abandonoSaveResponse,
  abandonoShowSaveModal: state.camionesIngreso.abandonoShowSaveModal
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_ABANDONO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(Abandono1))
